/* eslint-disable @typescript-eslint/consistent-type-assertions */

import React from "react";
import LoadingScreen from "~/areas/infrastructure/components/LoadingScreen/LoadingScreen";
import type { OctopusError } from "~/client/resources";
import { client } from "~/clientInstance";
import BaseComponent from "~/components/BaseComponent";
import { logger } from "~/utils/logging/logger";

interface ClientConnectorProps {
    renderWhenConnected: () => JSX.Element;
}

interface ClientConnectorState {
    inProgressMessage: string;
    connectError: OctopusError | null;
    isConnected: boolean;
}

interface ClientConnectorProps {
    renderWhenConnected: () => JSX.Element;
}

export class ClientConnector extends BaseComponent<ClientConnectorProps, ClientConnectorState> {
    constructor(props: ClientConnectorProps) {
        super(props);
        this.state = {
            isConnected: false,
            connectError: null,
            inProgressMessage: "Trying to connect to Octopus",
        };
    }

    async componentDidMount() {
        await this.connectClient();
    }

    async connectClient() {
        await client.connect((progress: string, error: OctopusError | undefined) => {
            logger.info("Connecting to client, progress: {progress}", { progress });
            if (error) {
                logger.error(error, "Error connecting to client");
            }
            this.setState({ inProgressMessage: progress, connectError: error as OctopusError });
        });

        this.setState({ isConnected: true });
    }

    render() {
        return this.state.isConnected ? this.props.renderWhenConnected() : <LoadingScreen errorDetails={this.state.connectError} inProgressMessage={this.state.inProgressMessage} />;
    }
}
